import {
  Component,
  OnInit,
  Input,
  Inject,
  ViewChild,
  ElementRef
} from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA,
  MatLegacyDialogRef
} from '@angular/material/legacy-dialog';
import { GetItemListFieldsService } from '../../../shared/services/get-item-list-fields.service';
import { Observable, fromEvent, Subject } from 'rxjs';
import { map, startWith, delay, tap } from 'rxjs/operators';

@Component({
  selector: 'ab-country-list-popup',
  templateUrl: './country-list-popup.component.html',
  styleUrls: ['./country-list-popup.component.scss']
})
export class CountryListPopupComponent implements OnInit {
  @Input() countryList: any;
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;

  public selectedCountry: any;
  public items: any;
  public search: string;
  public filteredArray: Observable<any[]>;
  public isEmpty = false;

  private _searchSubject;

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: any,
    public dialogRef: MatLegacyDialogRef<CountryListPopupComponent>,
    private getItemListFieldsService: GetItemListFieldsService
  ) {}

  ngOnInit() {
    if (this.data.fields && this.data.fields.length !== 0) {
      this.items = this.getItemListFieldsService.getItems(
        this.data.fields.items
      );
    }

    this.filteredArray = this.searchObservable.pipe(
      startWith(null),
      map((event) => {
        return this.search ? this.filter() : this.data.data;
      }),
      delay(0),
      tap((value) => {
        this.isEmpty = value.length === 0;
      })
    );
  }

  confirm(country: any) {
    this.selectedCountry = country;
    this.dialogRef.close(this.selectedCountry);
  }

  clearValue() {
    this.search = '';
    this._searchSubject.next();
  }

  private filter() {
    return this.data.data.filter((country) => {
      return (
        country.countryName
          .toLowerCase()
          .indexOf(this.search.toLocaleLowerCase()) !== -1
      );
    });
  }

  private get searchObservable(): Observable<any> {
    if (!this._searchSubject) {
      this._searchSubject = new Subject();

      fromEvent(this.searchInput.nativeElement, 'input').subscribe((event) => {
        this._searchSubject.next(event);
      });
    }

    return this._searchSubject.asObservable();
  }
}
